class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.mobileToggle = document.querySelector('.search-toggle-button');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.mobileToggle.addEventListener(
      'click',
      this.mobileModalOpener.bind(this)
    );

    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
  }
  mobileModalOpener(event) {
    this.detailsContainer.setAttribute('open', true);

    if(this.detailsContainer.querySelector('.search__input')) {
      setTimeout(function() {
        this.triggerFocus(this.detailsContainer.querySelector('.search__input'));
      }.bind(this), 100);
    }
    //this.onSummaryClick(event);
  }
  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    let details = event.target.closest('details');
    if(!details) {
      details = event.target.closest('sticky-header').querySelector('details');
    }
    details.hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if(event.target.closest('.tagalys-search-suggestions') || event.target.classList.contains('tagalys-search-suggestions')) {
      return;
    }
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }


  triggerFocus(element) {
    let eventType = "onfocusin" in element ? "focusin" : "focus";
    let bubbles = "onfocusin" in element;
    let event;

    if ("createEvent" in document) {
        event = document.createEvent("Event");
        event.initEvent(eventType, bubbles, true);
    }
    else if ("Event" in window) {
        event = new Event(eventType, { bubbles: bubbles, cancelable: true });
    }

    element.focus();
    element.dispatchEvent(event);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    let details = event.target.closest('details');
    if(!details) {
      details = event.target.closest('sticky-header').querySelector('details');
    }
    details.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    // trapFocus(
    //   this.detailsContainer.querySelector('[tabindex="-1"]'),
    //   this.detailsContainer.querySelector('input:not([type="hidden"])')
    // );

    if(details.querySelector('.search__input')) {
      setTimeout(function() {
        this.triggerFocus(details.querySelector('.search__input'));
      }.bind(this), 100);
    }
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    this.detailsContainer.querySelector('input.search__input').blur();
  }
}

customElements.define('details-modal', DetailsModal);
